module.exports = __webpack_public_path__ + "static/img/product_yqm.6582caf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessPlatform/product_yqm.png
// module id = S8cI
// module chunks = 0